import createIcon from '@/lib/create-icon'

const TvShowsAndMoviesIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      fill='none'
      d='M3.83325 26.8333C3.83325 19.6052 3.83325 15.991 6.07876 13.7455C8.32429 11.5 11.9384 11.5 19.1666 11.5H26.8333C34.0614 11.5 37.6756 11.5 39.921 13.7455C42.1666 15.991 42.1666 19.6052 42.1666 26.8333C42.1666 34.0615 42.1666 37.6757 39.921 39.9211C37.6756 42.1667 34.0614 42.1667 26.8333 42.1667H19.1666C11.9384 42.1667 8.32429 42.1667 6.07876 39.9211C3.83325 37.6757 3.83325 34.0615 3.83325 26.8333Z'
      stroke='url(#paint0_linear_5314_706)'
      strokeWidth='2.875'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M3.83325 26.8333C3.83325 19.6052 3.83325 15.991 6.07876 13.7455C8.32429 11.5 11.9384 11.5 19.1666 11.5H26.8333C34.0614 11.5 37.6756 11.5 39.921 13.7455C42.1666 15.991 42.1666 19.6052 42.1666 26.8333C42.1666 34.0615 42.1666 37.6757 39.921 39.9211C37.6756 42.1667 34.0614 42.1667 26.8333 42.1667H19.1666C11.9384 42.1667 8.32429 42.1667 6.07876 39.9211C3.83325 37.6757 3.83325 34.0615 3.83325 26.8333Z'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M3.83325 26.8333C3.83325 19.6052 3.83325 15.991 6.07876 13.7455C8.32429 11.5 11.9384 11.5 19.1666 11.5H26.8333C34.0614 11.5 37.6756 11.5 39.921 13.7455C42.1666 15.991 42.1666 19.6052 42.1666 26.8333C42.1666 34.0615 42.1666 37.6757 39.921 39.9211C37.6756 42.1667 34.0614 42.1667 26.8333 42.1667H19.1666C11.9384 42.1667 8.32429 42.1667 6.07876 39.9211C3.83325 37.6757 3.83325 34.0615 3.83325 26.8333Z'
      stroke='url(#paint1_radial_5314_706)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M17.25 5.75016L23 11.5002L30.6667 3.8335'
      stroke='url(#paint2_linear_5314_706)'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M17.25 5.75016L23 11.5002L30.6667 3.8335'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M17.25 5.75016L23 11.5002L30.6667 3.8335'
      stroke='url(#paint3_radial_5314_706)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5314_706'
        x1='3.83325'
        y1='11.5'
        x2='40.8751'
        y2='43.6544'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_5314_706'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(22.9999 42.1667) scale(19.1667 15.6166)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint2_linear_5314_706'
        x1='17.25'
        y1='3.8335'
        x2='26.4283'
        y2='14.9877'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint3_radial_5314_706'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23.9583 11.5002) scale(6.70833 3.90415)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'TvShowsAndMoviesIcon'
)

export default TvShowsAndMoviesIcon
